import { render } from "./payment-page.vue?vue&type=template&id=7ecef3a4&scoped=true"
import script from "./payment-page.vue?vue&type=script&lang=js"
export * from "./payment-page.vue?vue&type=script&lang=js"

import "./payment-page.vue?vue&type=style&index=0&id=7ecef3a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ecef3a4"]])

export default __exports__